import { render, staticRenderFns } from "./WebhookDetailsModal.vue?vue&type=template&id=2926029d&"
import script from "./WebhookDetailsModal.vue?vue&type=script&lang=js&"
export * from "./WebhookDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports